module.exports = __webpack_public_path__ + "img/diamond_placeholder.036c2d32.jpeg";